module.exports = __webpack_public_path__ + "img/em-tao-process-01.cd12e798.webp";